import { Splide } from './telysi-ref-v2-splide.js';

function init(root){
  if(!root||root.dataset.initialized)return;
  root.dataset.initialized='true';
  root.querySelectorAll('[data-telysi-component="splide-component"]').forEach(wrapper=>{
    const el=wrapper.querySelector('.splide');if(!el)return;
    const d=wrapper.dataset;
    let options={type:d.type||'slide',perPage:+d.slidesDesktop||3,perMove:+d.perMoveDesktop||1,gap:`${d.gapDesktop||28}px`,padding:`${d.sidePaddingDesktop||0}px`,arrows:true,pagination:true,autoplay:d.autoplay==='true',interval:(+d.autoplaySpeed||5)*1000,breakpoints:{749:{perPage:+d.slidesMobile||1,gap:`${d.gapMobile||12}px`,padding:`${d.sidePaddingMobile||0}px`}},reducedMotion:{speed:0,rewindSpeed:0,autoplay:'pause'}};
    if(d.destroyDesktop==='true'){
      options={...options,mediaQuery:'min',perPage:+d.slidesMobile||1,gap:`${d.gapMobile||15}px`,padding:`${d.sidePaddingMobile||15}px`,breakpoints:{750:{destroy:true}}};
    }
    options.omitEnd=d.omitEnd==='true'; el.telysiSplide=new Splide(el,options).mount();
  });
  root.querySelectorAll('[data-telysi-component="content-tabs"]').forEach(group=>{
    const buttons=[...group.querySelectorAll('.content-tab-button')];const panels=[...group.querySelectorAll('.content-tab')];
    const activate=index=>{
      buttons.forEach((b,i)=>{b.classList.toggle('content-tab-button--active',i===index);b.setAttribute('aria-selected',String(i===index));b.tabIndex=i===index?0:-1;});
      panels.forEach((p,i)=>{p.hidden=i!==index;p.classList.toggle('content-tab--active',i===index);});
      const indicator=group.querySelector('.content-tab-buttom__active-bg');
      if(indicator){indicator.style.width=`${buttons[index].offsetWidth}px`;indicator.style.left=`${buttons[index].offsetLeft}px`;}
    };
    group.querySelector('.content-tabs__buttons')?.setAttribute('role','tablist');
    buttons.forEach((b,i)=>{b.setAttribute('role','tab');b.id=`telysi-tab-${i}`;b.setAttribute('aria-controls',`telysi-panel-${i}`);b.addEventListener('click',()=>activate(i));b.addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const n=e.key==='Home'?0:e.key==='End'?buttons.length-1:(i+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length;activate(n);buttons[n].focus();});});
    panels.forEach((p,i)=>{p.id=`telysi-panel-${i}`;p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',`telysi-tab-${i}`);});activate(0);
  });
  const rows=[...root.querySelectorAll('[data-ingredient-id]')];
  rows.forEach(row=>{
    const activate=()=>{rows.forEach(r=>{r.classList.toggle('active',r===row);r.setAttribute('aria-pressed',String(r===row));});root.querySelectorAll('[data-detail-id]').forEach(p=>p.classList.toggle('active',p.dataset.detailId===row.dataset.ingredientId));};
    row.addEventListener('click',activate);row.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();activate();}});
  });
  const videos=root.querySelectorAll('video');
  const observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{if(!isIntersecting||target.dataset.loaded)return;target.dataset.loaded='true';target.querySelectorAll('source[data-src]').forEach(s=>s.src=s.dataset.src);target.load();if(!matchMedia('(prefers-reduced-motion: reduce)').matches)target.play().catch(()=>{});}),{rootMargin:'200px'});
  videos.forEach(v=>observer.observe(v));
}
init(document.querySelector('#telysi-reference-details'));
document.addEventListener('shopify:section:load',()=>init(document.querySelector('#telysi-reference-details')));

(function(){const root=window.document.querySelector('#telysi-reference-details');if(!root)return;const document={querySelector:s=>root.querySelector(s),querySelectorAll:s=>root.querySelectorAll(s),addEventListener:(event,fn)=>{if(event==='DOMContentLoaded')fn();}};const Shopify={designMode:false};
  function initSteps12template16707342565470__ss_steps_12_YCyjtT() {
    const wrapElement = document.querySelector('.steps-wrap-template--16707342565470__ss_steps_12_YCyjtT');
    if (!wrapElement) return;

    let currentMode = null;
    let scrollHandler = null;
    let resizeTimeout = null;

    function cleanupHandlers() {
      if (scrollHandler) {
        window.removeEventListener('scroll', scrollHandler);
        scrollHandler = null;
      }
    }

    function resetMobileStyles() {
      const progressBarBg = document.querySelector('.steps-progress-bar-background-template--16707342565470__ss_steps_12_YCyjtT');
      const progressBarProgress = document.querySelector('.steps-progress-bar-progress-template--16707342565470__ss_steps_12_YCyjtT');
      
      if (progressBarBg) progressBarBg.style.background = '';
      if (progressBarProgress) progressBarProgress.style.background = '';
    }

    function resetDesktopStyles() {
      const progressBar = wrapElement.querySelector('.steps-progress-bar-progress-template--16707342565470__ss_steps_12_YCyjtT');
      const dots = wrapElement.querySelectorAll('.steps-item-icon-template--16707342565470__ss_steps_12_YCyjtT');
      const items = wrapElement.querySelectorAll('.steps-item-template--16707342565470__ss_steps_12_YCyjtT');
      
      if (progressBar) progressBar.style.height = '';
      
      dots.forEach((dot) => {
        dot.style.opacity = '';
      });
      
      items.forEach((item) => {
        const itemBadge = item.querySelector('.steps-item-badge-template--16707342565470__ss_steps_12_YCyjtT');
        const itemHeading = item.querySelector('.steps-item-heading-template--16707342565470__ss_steps_12_YCyjtT');
        const itemText = item.querySelector('.steps-item-text-template--16707342565470__ss_steps_12_YCyjtT');
        if (itemBadge) itemBadge.style.opacity = '';
        if (itemHeading) itemHeading.style.opacity = '';
        if (itemText) itemText.style.opacity = '';
      });
    }

    function updateMobileProgressBar() {
      if (window.innerWidth >= 1024) return;

      const progressBarBg = document.querySelector('.steps-progress-bar-background-template--16707342565470__ss_steps_12_YCyjtT');
      const progressBarProgress = document.querySelector('.steps-progress-bar-progress-template--16707342565470__ss_steps_12_YCyjtT');
      const itemWraps = document.querySelectorAll('.steps-item-wrap-template--16707342565470__ss_steps_12_YCyjtT');
      const progressBarElement = document.querySelector('.steps-progress-bar-template--16707342565470__ss_steps_12_YCyjtT');
      
      if (!progressBarBg || !progressBarElement || itemWraps.length === 0) return;

      const progressBarRect = progressBarElement.getBoundingClientRect();
      const progressBarTop = progressBarRect.top + window.scrollY;
      const progressBarHeight = progressBarRect.height;

      let gradientStops = [];
      let currentPosition = 0;

      itemWraps.forEach((wrap) => {
        const wrapRect = wrap.getBoundingClientRect();
        const wrapTop = wrapRect.top + window.scrollY;
        const wrapBottom = wrapTop + wrapRect.height;

        const startPercent = Math.max(0, ((wrapTop - progressBarTop) / progressBarHeight) * 100);
        const endPercent = Math.min(100, ((wrapBottom - progressBarTop) / progressBarHeight) * 100);

        if (currentPosition < startPercent) {
          gradientStops.push(`#121212 ${currentPosition}%`);
          gradientStops.push(`#121212 ${startPercent}%`);
        }

        gradientStops.push(`transparent ${startPercent}%`);
        gradientStops.push(`transparent ${endPercent}%`);

        currentPosition = endPercent;
      });

      if (currentPosition < 100) {
        gradientStops.push(`#121212 ${currentPosition}%`);
        gradientStops.push(`#121212 100%`);
      }

      const gradient = `linear-gradient(to bottom, ${gradientStops.join(', ')})`;
      progressBarBg.style.background = gradient;

      if (progressBarProgress) {
        progressBarProgress.style.background = gradient;
      }
    }

    function updateDesktopProgress() {
      if (window.innerWidth < 1024) return;

      const progressBar = wrapElement.querySelector('.steps-progress-bar-progress-template--16707342565470__ss_steps_12_YCyjtT');
      const progressBarBg = wrapElement.querySelector('.steps-progress-bar-background-template--16707342565470__ss_steps_12_YCyjtT');
      const dots = wrapElement.querySelectorAll('.steps-item-icon-template--16707342565470__ss_steps_12_YCyjtT');
      const items = wrapElement.querySelectorAll('.steps-item-template--16707342565470__ss_steps_12_YCyjtT');

      if (!progressBar || !progressBarBg || dots.length === 0 ) return;

      const progressBarBgRect = progressBarBg.getBoundingClientRect();
      const dotsPositions = [];
      
      dots.forEach((dot) => {
        const dotRect = dot.getBoundingClientRect();
        const relativeTop = dotRect.top + (dotRect.height / 2) - progressBarBgRect.top;
        dotsPositions.push(relativeTop);
      });

      const wrapRect = wrapElement.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const midScreen = windowHeight / 1.5;
      
      const wrapTop = wrapRect.top;
      const wrapBottom = wrapRect.bottom;
      const wrapHeight = wrapRect.height;
      
      let progressHeight;
      
      if (wrapBottom <= midScreen) {
        progressHeight = 100;
      } else if (wrapTop >= midScreen) {
        progressHeight = 0;
      } else {
        const distanceFromTopToMid = midScreen - wrapTop;
        const scrollProgress = Math.max(0, Math.min(1, distanceFromTopToMid / wrapHeight));
        progressHeight = scrollProgress * 100;
      }
      
      const progressBarHeight = progressBarBgRect.height;
      const currentProgressPx = (progressHeight / 100) * progressBarHeight;
      
      progressBar.style.height = `${progressHeight}%`;

      let activeIndex = 0;
      
      dots.forEach((dot, index) => {
        const item = items[index];
        const itemBadge = item ? item.querySelector('.steps-item-badge-template--16707342565470__ss_steps_12_YCyjtT') : null;
        const itemHeading = item ? item.querySelector('.steps-item-heading-template--16707342565470__ss_steps_12_YCyjtT') : null;
        const itemText = item ? item.querySelector('.steps-item-text-template--16707342565470__ss_steps_12_YCyjtT') : null;
        
        if (currentProgressPx >= dotsPositions[index]) {
          dot.style.opacity = '1';
          if (itemBadge) itemBadge.style.opacity = '1';
          if (itemHeading) itemHeading.style.opacity = '1';
          if (itemText) itemText.style.opacity = '1';
          activeIndex = index;
        } else {
          dot.style.opacity = '0.5';
          if (itemBadge) itemBadge.style.opacity = '0.5';
          if (itemHeading) itemHeading.style.opacity = '0.5';
          if (itemText) itemText.style.opacity = '0.5';
        }
      });
    }

    function initMobile() {
      resetDesktopStyles();
      updateMobileProgressBar();
      scrollHandler = updateMobileProgressBar;
      window.addEventListener('scroll', scrollHandler);
    }

    function initDesktop() {
      resetMobileStyles();
      
      const dots = wrapElement.querySelectorAll('.steps-item-icon-template--16707342565470__ss_steps_12_YCyjtT');
      const items = wrapElement.querySelectorAll('.steps-item-template--16707342565470__ss_steps_12_YCyjtT');
      
      if (dots[0]) {
        dots[0].style.opacity = '1';
        const firstItemBadge = items[0] ? items[0].querySelector('.steps-item-badge-template--16707342565470__ss_steps_12_YCyjtT') : null;
        const firstItemHeading = items[0] ? items[0].querySelector('.steps-item-heading-template--16707342565470__ss_steps_12_YCyjtT') : null;
        const firstItemText = items[0] ? items[0].querySelector('.steps-item-text-template--16707342565470__ss_steps_12_YCyjtT') : null;
        if (firstItemBadge) firstItemBadge.style.opacity = '1';
        if (firstItemHeading) firstItemHeading.style.opacity = '1';
        if (firstItemText) firstItemText.style.opacity = '1';
      }
      
      scrollHandler = updateDesktopProgress;
      window.addEventListener('scroll', scrollHandler);
      updateDesktopProgress();
    }

    function handleResize() {
      clearTimeout(resizeTimeout);
      
      resizeTimeout = setTimeout(() => {
        const newMode = window.innerWidth >= 1024 ? 'desktop' : 'mobile';
        
        if (newMode !== currentMode) {
          cleanupHandlers();
          currentMode = newMode;
          
          if (currentMode === 'desktop') {
            initDesktop();
          } else {
            initMobile();
          }
        } else {
          if (currentMode === 'desktop') {
            updateDesktopProgress();
          } else {
            updateMobileProgressBar();
          }
        }
      }, 100);
    }

    currentMode = window.innerWidth >= 1024 ? 'desktop' : 'mobile';
    
    if (currentMode === 'desktop') {
      initDesktop();
    } else {
      initMobile();
    }
    
    window.addEventListener('resize', handleResize);
  }

  document.addEventListener('DOMContentLoaded', initSteps12template16707342565470__ss_steps_12_YCyjtT);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:unload', initSteps12template16707342565470__ss_steps_12_YCyjtT);
    document.addEventListener('shopify:section:load', initSteps12template16707342565470__ss_steps_12_YCyjtT);
  }

})();
